import bunyan from 'bunyan'

const loggerLevel = process.env.BUNYAN_LOG_LEVEL || 'warn'

const loggerNames = [
  'serverLogger',
  'xhrLogger',
  'apiLogger',
  'sagasLogger',
  'functionLogger',
  'redirectLogger',
  'componentLogger'
]

let instance = null

export default class {
  constructor() {
    this.init = this.init.bind(this)

    if (!instance) {
      instance = this.init()
      instance.setupLoggers(loggerNames)
    }
    return instance
  }

  init() {
    return {
      loggers: {},

      debug(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).debug(responseData, msg)
        }
      },

      info(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).info(responseData, msg)
        }
      },

      warn(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).warn(responseData, msg)
        }
      },

      trace(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).trace(responseData, msg)
        }
      },

      fatal(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).fatal(responseData, msg)
        }
      },

      error(name, responseData, msg) {
        if (!global.window) {
          this.getLoggerInstance(name).error(responseData, msg)
        }
      },

      createLoggerInstance(name) {
        return bunyan.createLogger({
          name,
          level: loggerLevel
        })
      },

      getLoggerInstance(name) {
        if (!this.loggers[name]) {
          this.loggers[name] = this.createLoggerInstance(name)
        }

        return this.loggers[name]
      },

      getAllLoggers() {
        return Object.keys(this.loggers).map(key => {
          return this.loggers[key]
        })
      },

      setupLoggers(loggerNames) {
        loggerNames.forEach(name => {
          this.loggers[name] = this.createLoggerInstance(name)
        })
      }
    }
  }
}
